var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-item"},[_c('router-link',{attrs:{"tag":"a","to":_vm.resolvePath(_vm.item.path)}},[(_vm.item.note)?_c('svg-icon',{attrs:{"icon-class":_vm.item.note}}):_vm._e(),_vm._v(_vm._s(_vm.item.name))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }